import ChatPage from './chat';

export default function ProjectChatPage() {
    return <ChatPage />;
}


